import formatNumber from 'helpers/formatNumber';
import { Maths } from 'helpers/maths';
import getLoadUnitAbbreviation from 'screens/YieldV2/LoadDetails/helpers/getLoadUnitAbbreviation';

export default function formatAvgHarvestedQuantity(
  load,
  loadUnit,
  cropzoneTotalArea
) {
  if (load && loadUnit && cropzoneTotalArea) {
    return formatNumber(
      Maths.divideSafeRound(load, cropzoneTotalArea, 2),
      `${getLoadUnitAbbreviation(loadUnit)} / ac`
    );
  }
  return undefined;
}
